import { render, staticRenderFns } from "./BaseHomeworkArchiver.vue?vue&type=template&id=9bb49698&"
import script from "./BaseHomeworkArchiver.vue?vue&type=script&lang=js&"
export * from "./BaseHomeworkArchiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bb49698')) {
      api.createRecord('9bb49698', component.options)
    } else {
      api.reload('9bb49698', component.options)
    }
    module.hot.accept("./BaseHomeworkArchiver.vue?vue&type=template&id=9bb49698&", function () {
      api.rerender('9bb49698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseHomeworkArchiver.vue"
export default component.exports